<template>
  <section class="fill-height">
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title>Refill sessions</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>

      </template>
    </v-toolbar>

    <v-container fluid>
      <v-stepper v-model="stepper" >
        <v-stepper-header>
          <v-stepper-step :complete="stepper > 1" step="1">Choose sessions</v-stepper-step>
          <v-divider/>
          <v-stepper-step step="2">Finish</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form @submit="orderSessions">
              <div class="mb-3"></div>
              <v-slider v-for="(session_type, idx) in session_types" :key="idx"
                        class="py-3"
                        v-model="session_type.count"
                        :label="$vuetify.breakpoint.mdAndUp? session_type.name : session_type.short_name"
                        hide-details
                        max="10"
                        min="0"
                        thumb-label="always"
                        :thumb-size="24"
                        ticks
              ></v-slider>
              <v-divider></v-divider>
              <v-card-actions class="justify-center">
                <v-btn class="box-shadow" color="primary" @click="$router.back()">Cancel</v-btn>
                <v-btn class="box-shadow" color="success" type="submit">Continue</v-btn>
              </v-card-actions>
            </v-form>
          </v-stepper-content>
          <v-stepper-content step="2">
            <div class="text-center my-6">
              <v-icon color="primary" size="40">mdi-checkbox-marked-circle-outline</v-icon>
              <p class="ma-0">The application is successfully shipped!</p>
              <small class="ma-0">The results of your application will be sent to your email</small>
            </div>

            <div class="text-center">
              <v-divider class="mb-3"/>
              <v-btn color="primary" @click="$router.back()">Close</v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>

  </section>
</template>

<script>
export default {
  data: () => ({
    stepper: 1,
    session_types: [],
    api_errors: []
  }),
  created() {
    this.loadSessionTypes()
  },
  methods: {
    async loadSessionTypes() {
      this.session_types = await this.axios.get('api/session-types').then(({data}) => data.data)
    },
    orderSessions(e) {
      e.preventDefault()
      this.app_loading = true
      this.axios.post(`api/invoices`, {session_types: this.session_types})
          .then(() => { this.stepper++ })
          .catch(errors => { this.api_errors = errors.response.data.errors})
          .then(()=> { this.app_loading = false})
    }
  }
}
</script>